<div class="timer">
    <span>Elapsed time:</span>
    <span class="elapsed">00:00</span>
</div>